export var cifRu = ["301 201", "<g fill='none'><path fill='#FFF' d='M.5.5h300v100H.5z'/><path fill='#D52B1E' d='M.5 100.5h300v100H.5z'/><path fill='#0039A6' d='M.5 67.166h300v66.667H.5z'/></g>"];
